import { NoEmailError } from '../../errors/no-email-error';

export class NoEmailFacebookError extends NoEmailError {
	constructor(cause: any) {
		super(cause);
		this.name = 'NoEmailFacebookError';
	}
}
